import { gql } from '@apollo/client';

export const VideListItemFragment = gql`
  fragment VideoListItem on Video {
    _id
    enabled
    type
    name
    subject
    availableFrom
    availableTo
    thumbUrl
    isExternal
    externalUrl
  }
`;
